<template>
  <section class="news-section" v-if="$store.state.homeNews && $store.state.homeNews.length">
    <div class="news-section__container">
      <h2 class="news-section__title">Новости</h2>
      <ul class="news-section__row">
        <li class="news-section__column" v-for="(news, index) in $store.state.homeNews" :key="index">
          <router-link class="news" :to="{ name: 'article', params: { id: news.id } }" :title="news.title" :aria-label="news.title">
            <img class="news__image" :src="news.img350 | findSource($store.state.api)" :alt="news.title"/>
            <h3 class="news__title">{{ news.title }}</h3>
            <p class="news__subtitle">{{ news.subtitle | optimalTitle }}</p>
            <time class="news__date" v-if="news.date_publication" :datetime="news.date_publication | robotDate">{{ news.date_publication | humanDate }}</time>
            <time class="news__date" v-else :datetime="news.created_at | robotDate">{{ news.created_at | humanDate }}</time>
          </router-link>
        </li>
      </ul>
      <router-link :to="{ name: 'news' }" class="button-light">Все новости</router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NewsSection'
}
</script>
